export default {"src":"/org/_next/static/media/my-products.539ce3bc.svg","height":12,"width":17,"blurWidth":0,"blurHeight":0};